import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { BounceLoader } from 'react-spinners';
import PropTypes from 'prop-types';
import 'iframe-resizer';
import { useHistory } from 'react-router-dom';
import { oldSelfServiceLink, oidcConfig } from 'config';

const styles = {
  frame: {
    width: '1px',
    minWidth: '100%',
    border: 'none',
    visibility: 'hidden',
  },
  spinner: {
    width: '100%',
    position: 'relative',
    top: '200px',
    justifyContent: 'center',
    display: 'flex',
  },
};

const EmbedFrame = (props) => {
  const { frameSrc, classes, locationKey } = props;

  const [isFrameLoading, setIsFrameLoading] = useState(true);

  const frameRef = useRef(null);

  const history = useHistory();

  useEffect(() => {
    bindIframeOnLoadEvent();
  });

  const bindIframeOnLoadEvent = () => {
    if (!frameRef) return;

    frameRef.current.onload = () => {
      try {
        window.iFrameResize(
          {
            log: false,
            onMessage: (messageData) => {
              //receving iframe url (supports cross domain), TODO: check iframe link here
            },
          },
          '#selfserviceFrame'
        ); //resize the iframe to prevent scrolling
        window.scroll(0, 0);
        // console.log('Frame Source: ' + frame.contentWindow.location.href);
        checkIframeStillLoggedIn(frameRef.current);
      } catch (err) {
        console.error('EmbedFrame Error: ' + err);
      }
      setIsFrameLoading(false);
      frameRef.current.style.visibility = 'visible';
    };
  };

  const checkIframeStillLoggedIn = (frame) => {
    //Just a hack to check if the iframe app is logged out, this only works in the same origin (i.e.not locally with IIS Express)
    const frameLocation = frame.contentWindow.location.href.toLowerCase();
    const identityServerUrl = oidcConfig.authority.toLowerCase();
    const oldSsLink = oldSelfServiceLink.toLowerCase();
    if (
      frameLocation.includes(identityServerUrl + '/account/login') ||
      frameLocation.includes(identityServerUrl + '/account/logout')
    ) {
      history.push('/Logout');
    } else if (
      frameLocation === oldSsLink + '/customer' ||
      frameLocation === oldSsLink + '/customer/'
    ) {
      history.push('/');
    }
  };

  return (
    <div>
      <div className={classes.spinner}>
        <BounceLoader
          sizeUnit={'px'}
          size={30}
          color={'#123abc'}
          loading={isFrameLoading}
        />
      </div>
      <div>
        <iframe
          id={'selfserviceFrame'}
          key={locationKey}
          title={'embedded'}
          className={classes.frame}
          src={frameSrc}
          ref={frameRef}
        />
      </div>
    </div>
  );
};

EmbedFrame.propTypes = {
  classes: PropTypes.object.isRequired,
  frameSrc: PropTypes.string.isRequired,
  locationKey: PropTypes.string, //just to force refreshing the iframe
};

export default compose(withStyles(styles))(EmbedFrame);
